<template>
  <v-dialog v-model="show" max-width="700px">
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        class="mx-2"
        v-on="on"
      >
        Edit
      </v-btn>
    </template>
    <v-card>
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <ValidationProvider name="url" rules="required" v-slot="{ errors }">
            <v-text-field
              v-model="edited.url"
              label="Url"
              placeholder="Enter url"
              outlined
              dense
              :error-messages="errors[0]"
            />
          </ValidationProvider>
          <ValidationProvider name="img" rules="required" v-slot="{ errors }">
            <v-file-input
                v-model="edited.img_file"
                label="Main image"
                dense
                outlined
                accept="image/png"
                prepend-icon="mdi-file-image"
                :error-messages="errors[0]"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    color="primary"
                    dark
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
          </ValidationProvider>
          <ValidationProvider name="hover" rules="required" v-slot="{ errors }">
            <v-file-input
                v-model="edited.hover_file"
                label="Hover image"
                dense
                outlined
                accept="image/png"
                prepend-icon="mdi-file-image"
                :error-messages="errors[0]"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    color="primary"
                    dark
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="handleSubmit(save)">Save</v-btn>
        </v-card-actions>
    </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    entity: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      edited: {
        url: null,
        img_file: null,
        hover_file: null
      },
      default: {
        url: null,
        img_file: null,
        hover_file: null
      },
    }
  },
  methods: {
    closeDialog() {
      this.show = false;
      this.edited = Object.assign({}, this.default);
    },
    save() {
      this.$emit('save', { ...this.edited, type: this.type.replace('playmore_', '') });
      this.closeDialog();
    }
  },
  watch: {
    show(show) {
      if (show) {
        this.edited = Object.assign({}, this.entity);
      }
    }
  },
}
</script>